module.exports = __webpack_public_path__ + "img/2.f93297c5.jpg";